import { useState } from "react";
import { PrimaryButton } from "../UI";
import InputText from "../UI/InputText";
import PrimaryModal from "../UI/Modal/PrimaryModal";

const ProductModal = ({ action, data, hideModal, handleSubmit }) => {
  const [product, setProduct] = useState(data || { id: '', name: '', scope: '' });
  const [errors, setErrors] = useState({ id: '', name: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });

    if (value.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
  };

  const validateFields = () => {
    let valid = true;
    const newErrors = { id: '', name: '' };

    if (action === "create" && !product.id.trim()) {
      newErrors.id = "Product ID is required.";
      valid = false;
    }
    if (!product.name.trim()) {
      newErrors.name = "Product Name is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const onSubmit = () => {
    if (!validateFields()) return;

    let updatedProduct = product;

    if (action !== "create" && data) {
      updatedProduct = {id : data._id};
      Object.keys(product).forEach((key) => {
        if (product[key] !== data[key]) {
          updatedProduct[key] = product[key];
        }
      });
    }

    handleSubmit(updatedProduct);
    hideModal();
  };

  return (
    <PrimaryModal title={action === "create" ? "Create Product" : "Edit Product"} hideModal={hideModal}>
      <div className="p-6">
        {action === "create" && (
          <InputText
            id="id"
            label="Product ID"
            value={product.id}
            handleChange={handleChange}
            mandatory
            error={errors.id}
          />
        )}
        <InputText
          id="name"
          label="Product Name"
          value={product.name}
          handleChange={handleChange}
          mandatory
          error={errors.name}
        />
        <InputText
          id="scope"
          label="Scope"
          value={product.scope}
          handleChange={handleChange}
        />
        <div className="flex justify-end mt-4">
          <PrimaryButton handleClick={onSubmit}>
            {action === "create" ? "Create" : "Update"}
          </PrimaryButton>
        </div>
      </div>
    </PrimaryModal>
  );
};

export default ProductModal;